import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";
import type { ConsultationDisplayStatus } from "./consultation-types";

const STATUS_CONFIG: Record<
  ConsultationDisplayStatus,
  { label: string; pill: string; dot: string; spinner?: boolean }
> = {
  // Pencil x8meyH: setup is the one active-work state, so it reads blue with a
  // spinner instead of a static dot.
  setting_up: {
    label: "Setting up",
    pill: "bg-blue-50 text-blue-700",
    dot: "bg-blue-700",
    spinner: true,
  },
  // Pencil cB1BB / teamsMsg-D: waiting and in_progress are both neutral grey —
  // the blue is reserved for "Setting up".
  waiting: {
    label: "Waiting for replies",
    pill: "bg-muted text-muted-foreground",
    dot: "bg-muted-foreground/60",
  },
  in_progress: {
    label: "In progress",
    pill: "bg-muted text-muted-foreground",
    dot: "bg-muted-foreground/60",
  },
  answered: {
    label: "Answered",
    pill: "bg-surface-green text-green-content",
    dot: "bg-green-content",
  },
  needs_attention: {
    label: "Needs attention",
    pill: "bg-destructive/10 text-destructive",
    dot: "bg-destructive",
  },
  cancelled: {
    label: "Cancelled",
    pill: "bg-muted text-muted-foreground",
    dot: "bg-muted-foreground/60",
  },
  closed: {
    label: "Closed",
    pill: "bg-muted text-muted-foreground",
    dot: "bg-muted-foreground/60",
  },
};

export function ConsultationStatusBadge({
  displayStatus,
}: {
  displayStatus: ConsultationDisplayStatus;
}) {
  const config = STATUS_CONFIG[displayStatus];
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap px-2 py-0.5 text-[10px] font-medium",
        config.pill
      )}
    >
      {config.spinner ? (
        <Spinner className="size-2.5" aria-hidden />
      ) : (
        <span className={cn("size-1.5 rounded-full", config.dot)} aria-hidden />
      )}
      {config.label}
    </span>
  );
}
